export default {
  isSuper: 9, // FF
  isAdmin: [2, 92], // 病院管理者
  isPublic: [3, 93], // 閲覧専用
  notLogin: [1, 91] // 閲覧不可
}